import * as React from 'react';

const SvgChevronRight = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.64038 18.9455L9.05459 20.3597L17.4896 11.9247L9.05459 3.48962L7.64038 4.90384L14.661 11.9247L7.64038 18.9455Z", fill: "currentColor" }));

export { SvgChevronRight as default };
